import styled from 'styled-components';
import { compose } from 'styled-system';
import { Box } from '../Box/Box';
import { getOmittableProps } from '../helpers/omit';
import { flexContainer, flexItem, gapWorkaround } from '../helpers/styled';
export var justifyOptions = ['unset', 'flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly', 'stretch'];
var styleProps = getOmittableProps(flexContainer, flexItem);
export var Flex = /*#__PURE__*/styled(Box).withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !styleProps.has(p);
  }
}).withConfig({
  displayName: "Flex"
})(["display:flex;flex-wrap:wrap;", " ", ""], gapWorkaround, compose(flexContainer, flexItem));
Flex.supportsGap = !gapWorkaround;
var itemStyleProps = getOmittableProps(flexItem);
Flex.Item = styled.div.withConfig({
  shouldForwardProp: function shouldForwardProp(p) {
    return !itemStyleProps.has(p);
  },
  displayName: "Item"
})(flexItem);
Flex.Item.displayName = 'Flex.Item';
export default Flex;